import {
  DASHBOARD_LEVEL_SETUPS,
  NORMAL_TAB_SETUPS,
  SIDE_SHEET_SETUPS,
  SINGLE_FIELD_DASHBOARD_LEVEL_SETUPS,
  STYLE_CONFIG,
} from "../style-config/setupStyles";

export {
  DASHBOARD_LEVEL_SETUPS,
  NORMAL_TAB_SETUPS,
  SIDE_SHEET_SETUPS,
  SINGLE_FIELD_DASHBOARD_LEVEL_SETUPS,
  STYLE_CONFIG,
};

export const CDCM_ROLE_NAMES = [
  "CDCM - Office Manager",
  "CDCM - Accounting Manager",
  "CDCM - Parts Manager",
  "CDCM - Service Manager",
  "Setups Administrator",
];

export const CDCM_TITLE = "page.title.cdcmHome";

// When new setups are added. Update SETUP_STYLES and if the setup has a mismatched functional unit name that needs to be resolved, add it to MISMATCHED_FUNCTIONAL_UNIT_NAMES if needed.
export const PRIVLIB_SETUPS = [
  "AccountsPayable",
  "CashAppDefaults",
  "CashReceiptDefaults",
  "CashReceiptPymtTypes",
  "OnDemandChecks",
  "InvoiceAutoPost",
  "PORoleLevelInfo",
  "SEFlag",
  "ETCTimesheetDeclaration",
];

// this is similar to PRIVLIB_SETUPS, but maintained separetly as these are not purely PRIVLIB setups
export const RESTRICTED_SETUPS = [
  "ARDefaultConfig",
  "POVendorChangeControl",
  "EtcTechPayRecTypes",
  "EtcTimeZones",
  "ExpenseAllocations",
  "VendorCategory",
  "VendorCompanyType",
  "vendorCompanyTypeTab",
  "vendorCategoryTab",
];

export const NEW_ENTRY_RESTRICTED_SETUPS = [
  "GLCalendar",
  "GLFiscalYearEnd",
  "GLFiscalYearCalendar",
];

export const FEATURE_FLAG_KEYS = {
  BULK_UPLOAD: "enableBulkUploadFeature",
  ENABLE_PRIVLIB_SETUP_MANAGEMENT: "enablePrivlibSetupManagement",
  ENABLE_COMMON_AUDIT_FLOW: "enableCAFlow",
  ENABLE_COPY_GROUP_CODES: "enableCopyGroupCodes",
  ENABLE_FORM_RESET: "enableFormReset",
  ENABLE_SMARTLING_DROPDOWN: "enableSmartling",
  ENABLE_COPY_PO_UNITS_OF_MEASURE: "enableCopyUOM",
  ENABLE_SAVE_ON_CHANGE_FOR_EXISTING_RECORDS:
    "enableSaveOnChangeForExistingRecords",
  ENABLE_TOOLTIP: "enableToolTip",
  ENABLE_AR_RECORD_CONVERSION: "enableARRecordMigration",
  ENABLE_RBAC_SETUP_MANAGEMENT: "enableRBAC_UI",
  DEV_USER_ACCESS_LIST_KEY: "devuseraccesslist",
};

export const SCHEMA_SECTIONS = {
  GRID_FIELDS: "grid_fields",
  GENERAL_FIELDS: "general_fields",
  CORELATION_FIELDS: "corelation_fields",
  ADDITIONAL_FIELDS: "additional_fields",
  GROUPED_FIELDS: "grouped_fields",
};

export const SECTION_TITLE_OVERRIDES: Record<string, string> = {
  general_fields: "General Information",
  additional_fields: "Additional Information",
  corelation_fields: "Correlation Information",
  cash_disbursement: "Cash Disbursement Journal",
  cash_in_bank: "Cash In Bank Accounts",

  // PO Configuration Group
  poGroupTab: "Group",
  poAccountsTab: "Companies & Accounts",
  poAddressTab: "Shipping Info",
  shipViasTab: "Ship Via Info",
  poTypesTab: "Types",
  assign_po_numbers_fields: "Assign PO Numbers",
  po_gl_account: "Enter one GL Account default per Company for Pre-Invoicing",

  // Vendor Configuration Group
  vendorCompanyTypeTab: "Vendor Company Type",
  vendorCategoryTab: "Vendor Category",
  vendorPaymentTypesTab: "Vendor Payment Types",
  vendor_payment_fields: "Payment Methods",

  // Discounts
  generalFieldsTab: "General Information",
  customerPaySettingsTab: "Customer Pay Settings",
  internalPaySettingsTab: "Internal Pay Settings",
  warrantyPaySettingsTab: "Warranty Pay Settings",
};

export const SCHEMA_TITLES = {
  AR_PORTAL: "ARPortal",
  CASH_APP_DEFAULTS: "CashAppDefaults",
  CHART_OF_ACCOUNTS: "ChartOfAccounts",
  GL_FISCAL_YEAR_CALENDAR: "GLFiscalYearCalendar",
  PO_CONFIGURATION_GROUP: "POConfigurationGroup",
  PO_ROLE_LEVEL_INFO: "PORoleLevelInfo",
  PO_UNITS_OF_MEASURE: "POUnitsOfMeasure",
  RECURRING_JOURNAL_ENTRIES: "RecurringJrnlEntries",
  REPORT_GROUP_CODES: "ReportGroupCodes",
  REMITTANCE_FORM_MAPPING: "RemittanceFormMapping",
  INTERCO_TRANSFER: "IntercoTransfer",
  ACCOUNTS_RECEIVABLE: "AccountsReceivable",
  VENDOR_CONFIGURATION_GROUP: "VendorConfigurationGroup",
  LABOR_TYPES: "LaborTypes",
  DISCOUNTS: "Discounts",
  PAYMENT_TYPES: "PaymentTypes",
  INVENTORY_BUILDINGS: "InventoryBuildings",
  INVENTORY_ZONES: "InventoryZones",
  INVENTORY_ROUTES: "InventoryRoutes",
  INVOICE_AUTO_POST: "InvoiceAutoPost",
  ACCOUNTS_PAYABLE: "AccountsPayable",
  DEFAULT_LABOR_TYPES: "DefaultLaborTypes",
  ONDEMANDCHECKS: "OnDemandChecks",
  CAR_DESC_MODEL: "Model",
  CAR_DESC_MAKE: "Make",
  SE_FLAG: "SEFlag",
  CASH_CLEARING_SETUP: "CashClearingSetup",
  PRICING_MATRIX: "PricingMatrix",
  ETC_TIMESHEET_DECLARATION: "ETCTimesheetDeclaration",
  TRUCK_AP_INVOICES: "TruckAPInvoices",
  DICT_INV_NO:"DictInvNo"
};

export const AVAILABLE_BFF_TYPEAHEAD_SEARCH_EVALUATIONS = [
  "getWriteOffCOAScheduledAccounts",
  "getEformsProvisionId",
  "getEformsFormId",
  "fetchRemitToParentVendorIds",
  "getProductivityEmployeeIds",
];

export const SETUPS_TO_HIDE = [
  "GLCalendar",
  "GLFiscalYearEnd",
  "AccCompanyMasterData",
  "POGroups",
  "POTypes",
  "POItemBrand",
  "POGroupTenantLink",
  "POGroupCompany",
  "POShipVia",
  "POStatus",
  "POItemCategory",
  "POInvoiceStatus",
  "POCatalogItem",
  "POSecurityOperations",
  "POGroupMembers",
];

// Add newly implemented setup keys here
export const IMPLEMENTED_SETUP_KEYS: string[] = [
  "ARPortal",
  "AccountsPayable",
  "AccountsReceivable",
  "CAPDefaults",
  "COA",
  "CREDefaults",
  "CashClearingSetup",
  "CashInBanks",
  "Checks",
  "EtcAbsenceCodes",
  "EtcHolidays",
  "EtcPayPeriod",
  "EtcPayrollFields",
  "EtcTardyCodes",
  "EtcTechPayrollRecordTypes",
  "EtcTimeZones",
  "ExpenseAllocations",
  "GLFiscalYearCalendar",
  "GroupCodes",
  "IntercoTransfer",
  "InvoiceAutoPost",
  "JournalTemplates",
  "Journals",
  "LaserFormTable",
  "PaymentTypes", // CashReceiptPymtTypes
  "POConfigurationGroup",
  "PORoleLevelInfo", // PO Approval Limit
  "POVendorChangeControl",
  "RecurringJournalEntries",
  "RemitToParent",
  "RemittanceFormMapping",
  "SaleChains",
  "WriteOffs",
  "POUnitsOfMeasure",
  "VendorCategory",
  "VendorCompanyType",
  "VendorPaymentTypes",
  "VendorConfigurationGroup",
  "LaborTypes",
  "ServicePaymentTypes", // PaymentTypes
  "TaxCodes",
  "Discounts",
  "LaborPricingGrids",
  "InventoryBuildings",
  "DeniedCodes",
  "DefaultLaborTypes",
  "Model", // carDescModel
  "Make", // carDescMake
  "SEFlag",
  "ShopCharge",
  "ROSetups",
  "BankRecon",
  "TruckAPInvoices",
  "Story",
  "ServiceInvoice",
  "LaborServiceFeeCodes",
  "DispatchCodes",
  "DispatchServiceQuotes",
  "DispatchFlag",
  "EstimatingOptions",
  "AlrtSeq",
  "EROFlag",
  "PriorityVariables",
  "AppointmentSetups",
  "StatusCodes",
  "TransportTypes",
  "SpecialFees",
  "DealerInformation",
  "SplitTable",
  "DefaultAltg",
  "WorkOrderPrint",
  "Campaign",
  "CampaignApplInfo",
  "IndLaborCodes",
  "CampaignSetups",
  "TechPayPeriod",
  "SubletMarkups",
  "CampaignStatus",
  "PriceBreakTable",
  "JobPriorityConfig",
  "CustomPricing",
  "JobPriorityConfig",
  "PricingMatrix",
  "SystemNotifications",
  "Dispatch",
  "PaymentMappings",
  "GLCalendar",
  "GLFiscalYearEnd",
  "ETCTimesheetDeclaration",
  "ServicePricing",
  "DictInvNo",
];

// Third-party setups rendered via external iframe
export const THIRD_PARTY_SETUPS = ["CustomPricing", "SystemNotifications"];

export const GL_SETUPS = [
  "Journals",
  "COA",
  "SaleChains",
  "CashInBanks",
  "DetailGeneralLedger",
  "IntercoTransfer",
  "GroupCodes",
  "JournalTemplates",
  "RecurringJournalEntries",
  "Departments",
  "WriteOffs",
  "DataRetention",
  "ExpenseAllocations",
  "GLCalendar",
  "GLFiscalYearEnd",
  "Schedules",
  "AccCompanyMasterData",
  "LabourServiceFeeCodes",
  "LabourTypes",
  "Discounts",
  "POVendorChangeControl",
  "Reports",
  "ConsolidatedSchedulesReports",
  "CNumCompanyMapping",
  "CashClearingSetup",
  "WIPSplit",
  "CredsManager",
  "GLFiscalYearCalendar",
];

export const ENTERPRISE_LEVEL_SETUPS = ["IntercoTransfer", "BankRecon"];

export const DEPARTMENTS = {
  ACCOUNTING: "accounting",
  PARTS: "parts",
  SALES: "sales",
  SERVICE: "service",
  GENERAL: "general",
};

// table filter chips
export const CHIP_FILTER_FIELD_BY_SETUP = new Map([
  ["ReportGroupCodes", "group_code_type"],
]);

export const CORRELATION_GRID_COLUMNS_BY_PROPERTY_KEY = new Map([
  [
    "recurring_entry_reference",
    [
      "target_company_group_id",
      "account_number",
      "posting_amount",
      "control_1_number",
      "control_2_number",
      "posting_description",
      "statistical_count",
    ],
  ],
  [
    "journal_template_entry_reference",
    [
      "target_company_group_id",
      "account_number",
      "default_amount",
      "control_1_number",
      "control_2_number",
      "post_description",
      "statistical_count",
    ],
  ]
]);

export const CORRELATION_FILE_UPLOAD_ENABLED_KEYS = [
  "recurring_entry_reference",
];
